/* eslint-disable no-plusplus */

/**
 * Remove chars from beginning of string.
 */
import WHITE_SPACES from './whitespaces';

var ltrim = function ltrim(str) {
  var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WHITE_SPACES;
  var start = 0;
  var len = str.length;
  var charLen = chars.length;
  var found = true;
  var i;
  var c;

  while (found && start < len) {
    found = false;
    i = -1;
    c = str.charAt(start);

    while (++i < charLen) {
      if (c === chars[i]) {
        found = true;
        start++;
        break;
      }
    }
  }

  return start >= len ? '' : str.substr(start, len);
};

export default ltrim;